import { showSuccess, showError } from 'utils/messages';
import CreditCard from 'app/models/credit_card';
import CreditCardErrorModal from 'app/views/modals/credit_card_error_modal';
import EasyPostConstants from 'app/easypost_constants';

import tmpl from 'templates/credit_card_button';
import Base from 'app/views/base';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click .add_card': 'showStripe',
  },

  initialize(options) {
    this.priority = options.priority;
    this.errorModal = new CreditCardErrorModal({});
  },

  context() {
    return {
      has_payment_method: !this.model.isNew(),
    };
  },

  showStripe(e) {
    e.preventDefault();
    const self = this;

    if (!window.StripeCheckout) {
      showError('Credit card payment gateway failed to load. Try reloading this page.');
      throw new Error('Stripe failed to load: window.StripeCheckout not present');
    }

    window.StripeCheckout.open({
      key: EasyPostConstants.StripePublicKey,
      address: true,
      name: 'EasyPost',
      description: 'A Simple Shipping API',
      panelLabel: 'Add Card',
      token(response) {
        new CreditCard({}).save({
          stripe_object_id: response.id,
          priority: self.priority,
        }, {
          success(model) {
            self.model.set(`${self.priority}_payment_method`, model);
            showSuccess('Credit card successfully added to your account');
          },
          error(model, res) {
            const responseBody = JSON.parse(res.responseText);
            self.errorModal.message = responseBody.error.message;
            self.errorModal.show();
          },
        });
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/credit_card_button_view.js